import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { userApi } from '../services/api';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30分钟
const WARNING_TIME = 5 * 60 * 1000; // 提前5分钟警告

export const SessionTimeout = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const logout = async () => {
    try {
      await userApi.logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
    localStorage.clear();
    message.warning('会话已过期，请重新登录');
    navigate('/login');
  };

  const resetTimer = () => {
    lastActivityRef.current = Date.now();
    
    // 清除旧的定时器
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);
    
    // 设置警告定时器
    warningRef.current = setTimeout(() => {
      message.warning('您的会话即将过期，请继续操作以保持登录状态', 10);
    }, SESSION_TIMEOUT - WARNING_TIME);
    
    // 设置超时定时器
    timeoutRef.current = setTimeout(() => {
      logout();
    }, SESSION_TIMEOUT);
  };

  useEffect(() => {
    const isLogin = localStorage.getItem('isLogin');
    if (!isLogin) return;

    // 监听用户活动
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    
    const handleActivity = () => {
      const now = Date.now();
      // 节流：1分钟内只重置一次
      if (now - lastActivityRef.current > 60000) {
        resetTimer();
      }
    };

    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // 初始化定时器
    resetTimer();

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (warningRef.current) clearTimeout(warningRef.current);
    };
  }, []);

  return null;
};
